import React, { useState, useEffect } from 'react';
import { getAdminPanelApiUrl } from '../../../config/api';
import './AdminCouponOrdersManager.css';

const AdminCouponOrdersManager = () => {
    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [updating, setUpdating] = useState(null);

    const statusLabels = {
        'pending': { label: 'Ожидает', class: 'status-pending' },
        'contacted': { label: 'Связались', class: 'status-contacted' },
        'in_progress': { label: 'В работе', class: 'status-in-progress' },
        'completed': { label: 'Завершен', class: 'status-completed' },
        'cancelled': { label: 'Отменен', class: 'status-cancelled' }
    };

    const fetchOrders = async () => {
        try {
            setLoading(true);
            const response = await fetch(getAdminPanelApiUrl('special_offer/admin_get_coupon_orders_simple.php'));
            const data = await response.json();

            if (data.status === 'success') {
                setOrders(data.orders);
            } else {
                setError(data.message || 'Ошибка при загрузке заказов');
            }
        } catch (err) {
            setError('Ошибка сети при загрузке заказов');
        } finally {
            setLoading(false);
        }
    };

    const updateOrderStatus = async (orderId, newStatus) => {
        // Пока просто обновляем локально, без API
        setOrders(prevOrders =>
            prevOrders.map(order =>
                order.id === orderId
                    ? { ...order, status: newStatus }
                    : order
            )
        );
    };

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleString('ru-RU', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    useEffect(() => {
        fetchOrders();
    }, []);

    if (loading) {
        return <div className="admin-coupon-orders-loading">Загрузка заказов...</div>;
    }

    if (error) {
        return <div className="admin-coupon-orders-error">Ошибка: {error}</div>;
    }

    return (
        <div className="admin-coupon-orders">
            <div className="admin-coupon-orders-header">
                <h2>Заказы купонов</h2>
                <button onClick={fetchOrders} className="refresh-btn">
                    🔄 Обновить
                </button>
            </div>

            <div className="admin-coupon-orders-stats">
                <div className="stat-card">
                    <span className="stat-number">{orders.length}</span>
                    <span className="stat-label">Всего заказов</span>
                </div>
                <div className="stat-card">
                    <span className="stat-number">
                        {orders.filter(order => order.status === 'pending').length}
                    </span>
                    <span className="stat-label">Ожидают</span>
                </div>
                <div className="stat-card">
                    <span className="stat-number">
                        {orders.filter(order => order.status === 'completed').length}
                    </span>
                    <span className="stat-label">Завершены</span>
                </div>
            </div>

            <div className="admin-coupon-orders-table">
                <table>
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Клиент</th>
                            <th>Email</th>
                            <th>Телефон</th>
                            <th>Услуга</th>
                            <th>Купон</th>
                            <th>Дата</th>
                            <th>Статус</th>
                            <th>Действия</th>
                        </tr>
                    </thead>
                    <tbody>
                        {orders.map(order => (
                            <tr key={order.id}>
                                <td>#{order.id}</td>
                                <td>{order.name}</td>
                                <td>
                                    <a href={`mailto:${order.email}`} className="email-link">
                                        {order.email}
                                    </a>
                                </td>
                                <td>
                                    <a href={`tel:${order.phone}`} className="phone-link">
                                        {order.phone}
                                    </a>
                                </td>
                                <td>{order.service}</td>
                                <td>
                                    <span className="coupon-code">
                                        {order.coupon_code}
                                    </span>
                                </td>
                                <td>{formatDate(order.created_at)}</td>
                                <td>
                                    <span className={`status-badge ${statusLabels[order.status].class}`}>
                                        {statusLabels[order.status].label}
                                    </span>
                                </td>
                                <td>
                                    <select
                                        value={order.status}
                                        onChange={(e) => updateOrderStatus(order.id, e.target.value)}
                                        disabled={updating === order.id}
                                        className="status-select"
                                    >
                                        {Object.entries(statusLabels).map(([value, { label }]) => (
                                            <option key={value} value={value}>
                                                {label}
                                            </option>
                                        ))}
                                    </select>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {orders.length === 0 && (
                <div className="admin-coupon-orders-empty">
                    Заказы купонов не найдены
                </div>
            )}
        </div>
    );
};

export default AdminCouponOrdersManager;